import React from "react";
import { Route, Link, Routes} from "react-router-dom";
import "./App.scss";
import "./components/scss/import.scss";
import IconHome from "./components/js/IconHome";
import IconProfile from "./components/js/IconProfile";
import IconDownload from "./components/js/IconDownload";
import IconCase from "./components/js/IconCase";
import IconContact from "./components/js/IconContact";
import Home from "./components/js/home";
import Profile from "./components/js/Profile";
import Contact from "./components/js/Contact";
import Case from "./components/js/Case";
import { Button } from "./components/js/button";
import profile from "./components/js/Profile";

const en = {
  label: "pl",
  homePageH1: "Hey, my name is Ilya.",
  homeTitle : "Start",
  profile: {
    title: "Profile",
    about: [
      "I am a front-end/web developer with two years of experience, primarily working in the e-marketing industry.",
      "Throughout my work, I strive to continuously improve my skills to create attractive and interactive websites.",
      "Furthermore, I value my communication abilities, which enable me to collaborate effectively with both teams and clients.",
      "Finding joy in the ever-evolving nature of this industry and being able to work on innovative projects, my goal is to keep progressing and meet clients' needs while taking on more advanced projects."
    ],
  },
  case: {
    title: 'Projects',
    certificates: {
      title: "Certificates",
      descrFE: "Website development using HTML, CSS and JavaScript.",
      descrJS: "JavaScript web application development.",
      school: "COURSES EDUCATIONAL CENTER FOR PROGRAMMING AND HIGH TECH.",
    },
    exp: {
      title: "Projects",
    },
    petProjects: "",
  },
  contact: {
    title: "Сontact",
  },
  downloadNav : 'Download'
};
const pl = {
  label: "en",
  homePageH1: "Hej, mam na imie Ilya.",
  homeTitle : "Start",
  profile: {
    title: "Profil",
    about: [
      "Jestem front-end/web developerem z dwuletnim doświadczeniem. Pracowałem głównie w branży e-marketingowej.", "W trakcie mojej pracy staram się stale doskonalić swoje umiejętności, aby móc tworzyć atrakcyjne i interaktywne strony internetowe.", "Dodatkowo, cenię sobie zdolności komunikacyjne, które pomagają mi efektywnie współpracować zarówno z zespołem, jak i klientami.", "Rozwijanie się w tej dynamicznej branży oraz tworzenie innowacyjnych projektów sprawiają mi wiele radości. Moim celem jest kontynuowanie rozwoju, aby lepiej zaspokajać potrzeby klientów i podejmować się coraz bardziej zaawansowanych projektów.",
    ],
  },
  case: {
    title: 'Projekty',
    certificates: {
      title: "Certyfikaty",
      descrFE:
        "Tworzenie stron internetowych z wykorzystaniem HTML, CSS i JavaScript.",
      descrJS: "Tworzenie aplikacji internetowych JavaScript.",
      school: "KURSY CENTRUM EDUKACYJNE PROGRAMOWANIA I HIGH TECH.",
    },
    exp: {
      title: "Projekty",
    },
    petProjects: "",
  },
  contact: {
    title: "Kontakt",
  },
  downloadNav : 'Pobierz'
};

const App = () => {
  const lang = window.navigator.language === 'pl' ? pl : en;

  const [translate, setTranslate] = React.useState(lang);
  const handlerLanguage = () => {
    translate === pl ? setTranslate(en) : setTranslate(pl);
  };


  const navButtons = [
    <Link
      to="/"
      className="link"
      onClick={() => {
        if (menuVisibility) {
          handlerMenu();
        }
      }}
    >
      <IconHome />
        <span>{translate === en ? en.homeTitle : pl.homeTitle}</span>
    </Link>,
    <Link
      to="/Profile"
      className="link"
      onClick={() => {
        if (menuVisibility) {
          handlerMenu();
        }
      }}
    >
      <IconProfile />
        <span>{translate === en ? en.profile.title : pl.profile.title}</span>
    </Link>,
    <Link
      to="/Case"
      className="link"
      onClick={() => {
        if (menuVisibility) {
          handlerMenu();
        }
      }}
    >
      <IconCase />
      <span>{translate === en ? en.case.title : pl.case.title}</span>
    </Link>,
    <Link
      to="/Contact"
      className="link"
      onClick={() => {
        if (menuVisibility) {
          handlerMenu();
        }
      }}
    >
      <IconContact />
      <span>{translate === en ? en.contact.title : pl.contact.title}</span>

    </Link>,
    <a
      href="/cv/static/media/ILYA_NAHORNY_CV.pdf"
      download
      className="link"
      onClick={() => {
        if (menuVisibility) {
          handlerMenu();
        }
      }}
    >
      <IconDownload />
      <span>{translate === en ? en.downloadNav : pl.downloadNav}</span>
    </a>,
  ];



  const [menuVisibility, setMenuVisibility] = React.useState(false);

  const handlerMenu = () => {
    if (menuVisibility === false) {
      setMenuVisibility(true);
    }
    if (menuVisibility === true) {
      setMenuVisibility(false);
    }
  };

  return (
    <div className="App">
      <div
        className="languageToggle"
        id="languageToggle"
        onClick={handlerLanguage}
      >
        {translate.label}
      </div>
      <div className="menuToggle" id="menuToggle" onClick={handlerMenu}>
        <i>...</i>
      </div>
      <div className={menuVisibility ? "navigation-active" : "navigation"}>
        {navButtons.map((arr, ind) => {
          return arr;
        })}
      </div>

      <Routes>
          <Route path="/" element={<Home {...translate} />} exact />
          <Route path="/Profile" element={<Profile {...translate} />} exact />
          <Route path="/Contact" element={<Contact {...translate} />} exact />
          <Route path="/Case" element={<Case {...translate} />} exact />
          <Route path="*" element={<Home {...translate} />} />
      </Routes>
    </div>
  );
};

export default App;
